module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/score-bg-45108ce0570a5124ffdac73fc020b855.png";